import Swiper from 'swiper';
import { Autoplay, Keyboard, Navigation, Pagination, Scrollbar } from 'swiper/modules';

window.addEventListener('load', () => {

    const blockClassPrefix = '.wp-block-cs-core-ui-kit-carousel';

    document.querySelectorAll(blockClassPrefix).forEach((element) => {

        const swiper = element.querySelector(blockClassPrefix + ' .swiper');
        const attributes = JSON.parse(
            element.dataset.gutenbergAttributes
        );

        const carousel = new Swiper(swiper, {
            autoplay: attributes.autoplay ? { pauseOnMouseEnter: true } : false,
            autoHeight: true,
            keyboard: {
                enabled: true,
                onlyInViewport: true,
            },
            speed: 400,
            modules: [Autoplay, Keyboard, Navigation, Pagination, Scrollbar],
            slidesPerView: attributes.columnsMobile,
            spaceBetween: attributes.columnsMobile == 1 ? 0 : 16,
            pagination: attributes.pagination ? { el: element.querySelector('.swiper-pagination'), clickable: true } : false,
            navigation: attributes.arrows ? { nextEl: element.querySelector('.swiper-button-next'), prevEl: element.querySelector('.swiper-button-prev') } : false,
            scrollbar: attributes.scrollbar ? { el: element.querySelector('.swiper-scrollbar'), draggable: true, hide: false } : false,
            breakpoints: {
                768: {
                    slidesPerView: attributes.columnsTablet,
                    spaceBetween: attributes.columnsTablet == 1 ? 0 : 8
                },
                960: {
                    slidesPerView: attributes.columnsDesktop,
                    spaceBetween: attributes.columnsDesktop == 1 ? 0 : 12
                }
            }
        });

        const setTheme = () => {
            if (attributes.pagination) {
                element.querySelectorAll('.swiper-pagination-bullet').forEach(bullet => bullet.style.background = attributes.themeInactiveColor);
                element.querySelector('.swiper-pagination-bullet-active').style.background = attributes.themeActiveColor;
            }
            if (attributes.scrollbar) {
                element.querySelector('.swiper-scrollbar-drag').style.background = attributes.themeActiveColor;
            }
            if (attributes.arrows) {
                element.querySelector('.swiper-button-prev').style.color = attributes.themeActiveColor;
                element.querySelector('.swiper-button-next').style.color = attributes.themeActiveColor;
            }
        }

        setTheme();

        carousel.on('slideChange', setTheme);
    });
});
